// @flow
import HtmlPlayer from './html';
import HLSPlayer from './hls';
import FlashPlayer from './flash';
import ShakaPlayer from './shaka';

import {
   existy,
   isFunction,
   contains
} from '../utils';

// import isiOS from '../helpers/isiOS';

import type { Player$CombineOptions } from '../types/Options';

const CODEC = 'video/mp4; codecs=avc1.42E01E,mp4a.40.2';
const HLS_TYPES = [ 'application/x-mpegURL', 'vnd.apple.mpegURL', 'application/vnd.apple.mpegurl' ];

export const HLS_TYPE = 'HLS';
export const FLASH_TYPE = 'Flash';
export const HTML5_TYPE = 'HTML5';
export const SHAKA_TYPE = 'Shaka';

const MAP = {};
MAP[HLS_TYPE] = HLSPlayer;
MAP[FLASH_TYPE] = FlashPlayer;
MAP[HTML5_TYPE] = HtmlPlayer;
MAP[SHAKA_TYPE] = ShakaPlayer;

export default function createInstance(options: $Shape<Player$CombineOptions>, state) {
   const type = getPlayerType(options);
   const Player = MAP[type];
   return new Player(options, state);
}

export function getPlayerType(opts: $Shape<Player$CombineOptions>) {
   const {type, logger} = opts;

   if (opts.useHTMLPlayer) {
      logger.debug('Using html player for type: ', type);
      return HTML5_TYPE;
   }

   if (_canUseMediaSource() && (opts.useHLSJSPlayer || opts.isLive)) {
      logger.debug('Using hlsjs player for type: ', type);
      return HLS_TYPE;
   }

   logger.debug('Using shaka player for type: ', type);
   return SHAKA_TYPE;

   // INFO: This is the original code, but we are going to use Shaka player for all cases
   // if (isHLS(type)) {
   //    if ( _canUseNative4HLS() ) {
   //       logger.debug('Using native player for type: ', type);
   //       return HTML5_TYPE;
   //    }

   //    if (_canUseMediaSource()) {
   //       logger.debug('Using shaka player for type: ', type);
   //       return SHAKA_TYPE;
   //    }
   // } else if ( _canUseNativeMedia() ) {
   //    logger.debug('Using native player for type: ', type);
   //    return HTML5_TYPE;
   // }

   // logger.debug('Using shaka player for type: ', type);
   // return SHAKA_TYPE;
}

export function isHLS(type: string) {
   return contains(HLS_TYPES, type);
}

// function _canUseNative4HLS() {
//    const codec = 'application/vnd.apple.mpegURL';
//    const v = document.createElement('video');
//    let res = isiOS();
//    res = res && existy(v);
//    res = res && existy(v.canPlayType);
//    res = res && contains(['maybe', 'probably'], v.canPlayType(codec));
//    return res;
// }

function _canUseMediaSource() {
   const ms = window.MediaSource || window.WebKitMediaSource;
   return existy(ms) && isFunction(ms.isTypeSupported) && ms.isTypeSupported(CODEC);
}

// function _canUseNativeMedia() {
//    const v = document.createElement('video');
//    return existy(v) && existy(v.canPlayType) && v.canPlayType(CODEC);
// }
